<table mat-table [dataSource]="evaluaciones" #mytablePreiniciado class="my-table mat-elevation-z8">
  <!-- User Column -->
  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef> Nombre </th>
    <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
  </ng-container>

  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef> Versión </th>
    <td mat-cell *matCellDef="let element"> {{element.version}} </td>
  </ng-container>

  <ng-container matColumnDef="estructuraJerarquica">
    <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
    <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
  </ng-container>

  <!--
  <ng-container matColumnDef="escenario">
    <th mat-header-cell *matHeaderCellDef> Escenario </th>
    <td mat-cell *matCellDef="let element"> {{element.escenario.nombre}} </td>
  </ng-container>
  -->

  <ng-container matColumnDef="creador">
    <th mat-header-cell *matHeaderCellDef> Creador </th>
    <td mat-cell *matCellDef="let element"> {{element.creador?.nombreCompleto}} </td>
  </ng-container>

  <ng-container matColumnDef="dueno">
    <th mat-header-cell *matHeaderCellDef> Dueño </th>
    <td mat-cell *matCellDef="let element"> {{element.owner?.nombreCompleto}} </td>
  </ng-container>

  <ng-container matColumnDef="fechaInicio">
    <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
    <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
  </ng-container>

  <ng-container matColumnDef="fechaFin">
    <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
    <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
  </ng-container>

  <!-- Action Column -->
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef> Acción </th>
    <td mat-cell *matCellDef="let element" class="action-link">
      <a  (click)="print(element)" *ngIf="element.tieneImprimir">Imprimir</a>
      <span *ngIf="element.tieneImprimir && (element.tieneVer || element.tieneEditar)"> | </span>
      <a (click)="navegateTo('/evaluacion',element.id)" *ngIf="element.tieneVer && !element.tieneEditar">Ver</a> 
      <a  (click)="navegateTo('/evaluacion',element.id)" *ngIf="element.tieneEditar">Editar</a>
      <span *ngIf="element.tieneEliminar"> | </span>
      <a *ngIf="element.tieneEliminar" (click)="openDialog('Delete',element,'PRE_INICIADO')">Eliminar</a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
            (page)="OnePageChange($event)" showFirstLastButtons></mat-paginator>